import helperLocalStorage   from 'shared/mixins/helper-localstorage';

/**
 * @module
 */
 
const selector = '[data-js-form-restore]';
const formRestore = function(el, app) {
  
  const localStorageHelper = helperLocalStorage(app);
  const $el = $(el);
  const $label = $el.closest('.Ge-Label');
  const storageKey = app.cookiePrefix + '-form-save-' + ( $el.attr('data-js-form-saving') || $el.attr('name') );
  
  const init = function() {
    readStorage();
    registerEvents();
  };

  const registerEvents = function() {
    $el.on('clear',updateFromStorage);
  };
  
  const readStorage = function() {
    const value = localStorageHelper.get(storageKey,true);
    if (value) {
      updateFromStorage(value);
    }
  };
  
  const updateFromStorage = function (value) {
    const tagType = $el.prop('tagName').toLowerCase();
    const inputType = $el.attr('type');
    $el.attr('aria-busy',true);
    $label.addClass('Ge-Label--loaded');
    // delay slightly to allow other event listeners to be registered
    setTimeout(function() {
      if (['input','textarea','select'].indexOf(tagType) < 0) {
        $el.text(value);
      } else if ((inputType === 'radio' || inputType === 'checkbox') && $el.val() === value) {
        $el.prop('checked', true);
        $el.trigger('change');
      } else if ((inputType === 'radio' || inputType === 'checkbox') && $el.val() !== value) {
        $el.prop('checked', false);
        $el.trigger('change');
      } else {
        $el.val(value);
        $el.trigger('blur');
      }
      $el.trigger('fieldValidate');
      $el.attr('aria-busy',false);
    },200);
  };

  return {
    init: init()
  };
};

formRestore.selector = selector;

export default formRestore;
